import { motion } from "framer-motion";
import { Sparkles, X } from "lucide-react";

export const CollectionStrip = ({ collections: all, onPick }) => {
  const collections = all.filter((c) => c.product_count > 0);
  if (!collections.length) return null;
  return (
    <div className="mb-8" data-testid="collection-strip">
      <p className="mb-3 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-fuchsia-300">
        <Sparkles size={12} /> Festive collections
      </p>
      <div className="no-scrollbar -mx-1 flex gap-3 overflow-x-auto px-1 pb-1">
        {collections.map((c, i) => (
          <motion.button
            key={c.id}
            data-testid={`collection-card-${c.slug}`}
            onClick={() => onPick(c)}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.06 }}
            className="group relative h-28 w-60 shrink-0 overflow-hidden rounded-2xl border border-white/10 text-left sm:h-32 sm:w-72"
          >
            {c.banner ? (
              <img src={c.banner} alt="" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            ) : (
              <span className="absolute inset-0 bg-gradient-to-br from-fuchsia-500/30 via-[#12141A] to-cyan-400/20" />
            )}
            <span className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E] via-[#0A0B0E]/40 to-transparent" />
            <span className="absolute inset-x-0 bottom-0 p-3.5">
              <span className="block font-display text-base font-bold text-white">{c.name}</span>
              {c.tagline && <span className="block truncate font-mono text-[10px] uppercase tracking-[0.15em] text-cyan-300">{c.tagline}</span>}
            </span>
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export const CollectionBanner = ({ collection, count, onClear }) => (
  <motion.div
    data-testid="collection-banner"
    initial={{ opacity: 0, y: -8 }}
    animate={{ opacity: 1, y: 0 }}
    className="relative mb-8 overflow-hidden rounded-3xl border border-fuchsia-400/20"
  >
    {collection.banner ? (
      <img src={collection.banner} alt="" className="absolute inset-0 h-full w-full object-cover" />
    ) : (
      <span className="absolute inset-0 bg-gradient-to-br from-fuchsia-500/30 via-[#12141A] to-cyan-400/20" />
    )}
    <span className="absolute inset-0 bg-gradient-to-r from-[#0A0B0E] via-[#0A0B0E]/80 to-[#0A0B0E]/30" />
    <div className="relative flex items-center justify-between gap-4 p-5 sm:p-7">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-fuchsia-300">Collection</p>
        <h3 className="mt-1 font-display text-2xl font-extrabold text-white sm:text-3xl" data-testid="collection-banner-name">{collection.name}</h3>
        {collection.tagline && <p className="mt-1 text-sm text-slate-300">{collection.tagline}</p>}
        <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.15em] text-cyan-300" data-testid="collection-banner-count">{count} blanks in this set</p>
      </div>
      <button
        data-testid="collection-clear-btn"
        onClick={onClear}
        className="flex h-9 shrink-0 items-center gap-1.5 rounded-full border border-white/20 px-4 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-300 transition-colors hover:border-red-400/50 hover:text-red-300"
      >
        <X size={13} /> Clear
      </button>
    </div>
  </motion.div>
);
